import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-link",
  templateUrl: "./med-icon-link.component.html",
})
export class MedIconLinkComponent extends SvgMixinComponent {}
